import { render, staticRenderFns } from "./MenuEdition.vue?vue&type=template&id=9626e9c2&scoped=true&"
import script from "./MenuEdition.vue?vue&type=script&lang=js&"
export * from "./MenuEdition.vue?vue&type=script&lang=js&"
import style0 from "./MenuEdition.vue?vue&type=style&index=0&id=9626e9c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9626e9c2",
  null
  
)

export default component.exports